import { Button, Stack } from '@mui/material';
import { SelectElement, useFormContext } from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { AudiogramFormValues } from './AudiogramGenerator';

export function TemplateSelector() {
  const { $t } = useIntl();
  const { setValue, getValues } = useFormContext<AudiogramFormValues>();
  const templates = getValues('templates');

  const handleApplyTemplate = (templateId: string) => {
    const template = templates.find((t) => t.name === templateId);

    if (template) {
      Object.entries(template.data).forEach(([name, value]) =>
        setValue(`data.${name}` as keyof AudiogramFormValues, value as string),
      );
    }
  };

  if (!templates.length) {
    return null;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <SelectElement
        name="templateId"
        label={$t({
          id: 'audiogram.template',
          defaultMessage: 'Template',
        })}
        placeholder={$t({
          id: 'audiogram.selectTemplate',
          defaultMessage: 'Seleccionar template',
        })}
        options={
          templates.map((template) => ({
            id: template.name,
            label: template.name + (template.default ? ' (default)' : ''),
          })) || []
        }
        sx={{ minWidth: 200 }}
        size="small"
      />
      <Button
        variant="outlined"
        onClick={() => {
          const templateId = document.querySelector<HTMLInputElement>(
            'input[name="templateId"]',
          )?.value;
          if (templateId) {
            handleApplyTemplate(templateId);
          }
        }}
      >
        <FormattedMessage id="common.apply" defaultMessage="Aplicar" />
      </Button>
    </Stack>
  );
}
